import { useState, useEffect } from "react";
import { Form, FormGroup, Offcanvas } from "react-bootstrap";
import Select from "react-select";

import { useNavigate } from "react-router-dom";
import useLocalStorageState from "use-local-storage-state";
import { z } from "zod";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { GetRequest, PostRequest, PutRequest } from "../../Utils/hooks/ApiHandler";

const cleanTimeFormat = (timeString) => {
  if (!timeString) return "";

  // Remove AM/PM from 24-hour format times
  return timeString.replace(/ (AM|PM)$/i, "");
};
const createTaskSchema = z.object({
  task_name: z.string().min(1, "Please enter task name"),
  task_type: z.string().default("Call"),
  description: z.string().min(1, "Please enter description"),
  task_status: z.string().default("Open"),
  task_priority: z.string().default("High"),
  task_due_date: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date format (YYYY-MM-DD)") // for <input type="date">
    .refine((val) => !isNaN(Date.parse(val)), "Invalid date"),

  task_due_time: z
    .string()
    .regex(/^([01]\d|2[0-3]):([0-5]\d)$/, "Invalid time format (HH:mm)").trim(), // for <input type="time">
  task_reminder: z.string().default("No reminder"),
  task_assigned_to: z.string(),
});

export const Tasks = ({
  show,
  onCanvasClose,
  fetchAllTasks,
  contactId,
  setEditTask,
  editTask,
  taskId,
  ownerId
}) => {
  // const [selectedOption, setSelectedOption] = useState(null);
  // state for disable date and time if task status is completed
  const [taskStatus, setTaskStatus] = useState("open");
  const [selectedUser, setSelectedUser] = useState(null);
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();
  // Extract tokens from session
  const [customer, setCustomer] = useLocalStorageState("customer");
  const customerId = customer?.customer_details?.customer_id;
  const userLoginId = customer?.customer_details?.id;
  const token = customer?.token?.authorization;
  const rf = customer?.token?.authentication;
  const headers = {
    authentication: rf,
    Authorization: token,
  };
  const extras = { customer, setCustomer, rf, navigate };

  const {
    register,
    reset,
    handleSubmit,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(createTaskSchema),
    defaultValues: {
      task_assigned_to: ownerId
    }
  });

  const TASK_TYPE_OPTIONS = [
    { value: "call", label: "Call" },
    { value: "follow-up", label: "Follow-Up" },
    { value: "reminder", label: "Reminder" },
    { value: "todo", label: "Todo" },
  ];
  const STATUS_OPTIONS = [
    { value: "open", label: "Open" },
    { value: "inprogress", label: "Inprogress" },
    { value: "cancelled", label: "Cancelled" },
    { value: "completed", label: "Completed" },
  ];
  const PRIORITY_OPTIONS = [
    { value: "high", label: "High" },
    { value: "medium", label: "Medium" },
    { value: "low", label: "Low" },
  ];
  const TASK_OPTIONS = [
    { value: "15 minutes", label: "15 minutes" },
    { value: "30 minutes", label: "30 minutes" },
    { value: "1 hour", label: "1 hour" },
    { value: "2 hour", label: "2 hour" },
  ];

  // 1. Fetch existing task if editing
  useEffect(() => {
    if (editTask && taskId) {
      handleFetchEditTask();
    }
  }, [taskId]);

  const handleFetchEditTask = async () => {
    try {
      const res = await GetRequest(
        `contacts/getTaskDetailsForEdit/${taskId}`,
        { headers },
        { extras }
      );

      // react-hook-form reset for all fields
      reset({
        task_name: res.data[0].name,
        task_type: res.data[0].type,
        description: res.data[0].description,
        task_status: res.data[0].status,
        task_priority: res.data[0].priority,
        task_due_date: res.data[0].due_date,
        task_due_time: cleanTimeFormat(res.data[0].due_time.slice(0, 5)),
        task_reminder: res.data[0].reminder,
        task_status: res.data[0].task_status,
        task_assigned_to: res.data[0]?.assigned_to,
      });

      // setValue("task_name",res.data[0].name)

      // also update taskStatus state
      setTaskStatus(res.data.status);
    } catch (error) {
      console.error(error);
    }
  };
  // 2. Only set default date/time when creating new task
  useEffect(() => {
    if (!editTask) {
      const now = new Date();
      const today = now.toISOString().split("T")[0];
      const currentTime = now.toTimeString().slice(0, 5);

      setValue("task_due_date", today);
      setValue("task_due_time", currentTime);
    }
  }, [editTask, setValue]);

  // useEffect(()=>{
  //   if(editTask && taskId){
  //     const handleFetchEditTask = async()=>{
  //       try {
  //         const res = await GetRequest(`contacts/getTaskDetailsForEdit/${taskId}`, {headers}, {extras});
  //         setValue("task_name",res.data.name);
  //         setValue("task_type",res.data.type);
  //         setValue("description",res.data.description);
  //         setValue("task_status",res.data.status);
  //         setValue("task_priority",res.data.priority);
  //         setValue("task_due_date",res.data.due_date);
  //         setValue("task_due_time",res.data.due_time);
  //         setValue("task_reminder",res.data.reminder);
  //       } catch (error) {
  //         console.error(error)
  //       }
  //     }
  //     handleFetchEditTask()
  //   }
  // },[editTask, taskId])

  //USEEFFECT  for fetching task details by id
  // useEffect(()=>{
  //   handleFetchEditTask()
  // },[])

  const handleAssignUsers = async () => {
    const res = await GetRequest(
      `users/users/fetchUserAsOwner/${customerId}`,
      { headers },
      { extras }
    );


    if (res?.status === "success") {
      // React Select format: { value, label }
      const options = res?.data?.map((user) => ({
        value: user.id,
        label: user.full_name,
      }));
      setUsers(options);
    }
  };
  useEffect(() => {
    handleAssignUsers();
  }, []);

  const onFormSubmit = async (formData) => {
    try {

      const createPayload = {
        module_id: contactId,
        module_name: "contact",
        name: formData.task_name,
        type: formData.task_type,
        description: formData.description,
        task_status: formData.task_status,
        priority: formData.task_priority,
        due_date: formData.task_due_date,
        due_time: formData.task_due_time,
        reminder: formData.task_reminder,
        assigned_to: formData.task_assigned_to || ownerId,
        user_login_id: userLoginId,
      };

      const editPayload = {
        task_id: taskId,
        // module_name: "contact",
        name: formData.task_name,
        type: formData.task_type,
        description: formData.description,
        task_status: formData.task_status,
        priority: formData.task_priority,
        due_date: formData.task_due_date,
        due_time: formData.task_due_time,
        reminder: formData.task_reminder,
        assigned_to: formData.task_assigned_to || ownerId,
        user_login_id: userLoginId,
      }


      let res;
      if (editTask === true) {
        res = await PutRequest(
          `contacts/updateTask`,
          editPayload,
          { headers },
          extras
        );
      } else {
        res = await PostRequest(
          "contacts/createTask",
          createPayload,
          false,
          { headers },
          { extras }
        );
      }

      if (res.status === "success") {

        if (fetchAllTasks) fetchAllTasks();
        if (onCanvasClose) onCanvasClose();
        if (reset) reset();

      } else {
        console.error("Operation failed:", res.message || "Unknown error");

      }
    } catch (error) {
      console.error("Error in form submission:", error);

    }
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      padding: "0.1rem 0.75rem",
      minHeight: "50px",
      backgroundPosition: "right 0.4rem center",
      border: "1px solid #ccc",
    }),

    placeholder: (provided) => ({
      ...provided,
      margin: "1.2rem 0px 0rem",
      fontSize: "12px",
      fontWeight: 300,
      color: '#b4b4b4'

    }),
    singleValue: (provided) => ({
      ...provided,
      margin: "1.2rem 0px 0rem",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      paddingTop: "0.1rem",
      paddingBottom: "0.1rem",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "0.25rem",
    }),
  };


  return (
    <Offcanvas
      className="myDiv"
      placement="end"
      backdrop="static"
      show={show}
      onHide={onCanvasClose}
    // style={{ padding: 0 , width:"70vw !important"}}
    >
      <style>
        {`
          .myDiv {
            width: 70vw !important;
            padding: 0;
          }
        `}
      </style>
      <Offcanvas.Header
        closeButton
        style={{ borderBottom: "1px solid #d3f4ff" }}
      >
        <div
          className="d-flex justify-content-between"
          style={{ width: "97%" }}
        >
          <Offcanvas.Title style={{ lineHeight: "18px", color: 'rgb(7, 145, 255)' }}>
            {editTask === true ? 'Edit Task' : "Add Task"}
          </Offcanvas.Title>
        </div>
      </Offcanvas.Header>

      <Offcanvas.Body className="pt-0">
        <Form
          className="form-container"
          style={{ height: "91%" }}
          onSubmit={handleSubmit(onFormSubmit)}
        >
          <div className="row" style={{ height: "100%" }}>
            <div className="col-md-12 pt-3">
              <h4 style={{ fontSize: 19, fontWeight: 300, color: 'rgb(7, 145, 255)' }} className="ms-2">
                General Information
              </h4>
              <div
                className="row ms-0 w-100  mt-4"
                style={{ height: "fit-content" }}
              >
                <div className="col-md-6 mb-3">
                  <FormGroup className="position-relative focus-z-index">
                    <Form.Label htmlFor="" className="w-auto">
                      Task Name{" "} <span className="text-danger">*</span>
                    </Form.Label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter task name"
                      {...register("task_name")}
                      maxLength={125}
                    />
                    {errors.task_name && <p className="text-danger">{errors.task_name.message}</p>}
                  </FormGroup>
                </div>
                <div className="col-md-6 mb-3">
                  <FormGroup className="position-relative focus-z-index">
                    <Form.Label htmlFor="" className="w-auto">
                      Type
                    </Form.Label>
                    <Controller
                      name="task_type"
                      control={control}
                      render={({ field }) => (
                        <Select
                          options={TASK_TYPE_OPTIONS}
                          classNamePrefix="react-select"
                          styles={customStyles}
                          value={TASK_TYPE_OPTIONS.find((o) => o.value === field.value)}
                          onChange={(opt) => field.onChange(opt.value)}
                        />
                      )}
                    />
                  </FormGroup>
                </div>
                <div className="col-md-12 mb-3">
                  <FormGroup className="position-relative focus-z-index">
                    <Form.Label htmlFor="" className="w-auto">
                      Description <span className="text-danger">*</span>
                    </Form.Label>
                    <textarea
                      placeholder="Enter Description"
                      className="form-control"
                      {...register("description")}
                    ></textarea>
                    {errors.description && <p className="text-danger">{errors.description.message}</p>}
                  </FormGroup>
                </div>
                <div className="col-md-6 mb-3">
                  <FormGroup className="position-relative focus-z-index">
                    <Form.Label htmlFor="" className="w-auto">
                      Status{" "}
                    </Form.Label>
                    <Controller
                      name="task_status"
                      control={control}
                      render={({ field }) => (
                        <Select
                          options={STATUS_OPTIONS}
                          value={STATUS_OPTIONS.find(o => o.value === field.value)}
                          classNamePrefix="react-select"
                          styles={customStyles}
                          onChange={(opt) => field.onChange(opt.value)}
                        />
                      )}
                    />
                  </FormGroup>
                </div>
                <div className="col-md-6 mb-3">
                  <FormGroup className="position-relative focus-z-index">
                    <Form.Label htmlFor="" className="w-auto">
                      Priority{" "}
                    </Form.Label>
                    <Controller
                      name="task_priority"
                      control={control}
                      render={({ field }) => (
                        <Select
                          options={PRIORITY_OPTIONS}
                          value={PRIORITY_OPTIONS.find(o => o.value === field.value)}
                          classNamePrefix="react-select"
                          styles={customStyles}
                          onChange={(opt) => field.onChange(opt.value)}
                        />
                      )}
                    />
                  </FormGroup>
                </div>
                <div className="col-md-6 mb-3">
                  <FormGroup className="position-relative focus-z-index">
                    <Form.Label htmlFor="" className="w-auto">
                      Due Date{" "}
                    </Form.Label>
                    <div className="d-flex gap-2">
                      <input
                        type="date"
                        className="form-control"
                        name="task_due_date"
                        id="task_due_date"
                        readOnly={taskStatus === "completed"}
                        {...register("task_due_date")}
                      />
                      <input
                        type="time"
                        className="form-control"
                        style={{ width: "42%" }}
                        name="task_due_time"
                        id="task_due_time"
                        readOnly={taskStatus === "completed"}
                        {...register("task_due_time")}
                      />
                    </div>
                  </FormGroup>
                  {errors.task_due_time && <p className="text-danger">{errors.task_due_time.message}</p>}
                </div>
                <div className="col-md-6 mb-3">
                  <FormGroup
                    style={{
                      display:
                        `${taskStatus}` === "completed" ? "none" : "block",
                    }} className="position-relative focus-z-index"
                  >
                    <Form.Label htmlFor="" className="w-auto">
                      Reminder due before
                    </Form.Label>
                    <Controller
                      name="task_reminder"
                      control={control}
                      render={({ field }) => (
                        <Select
                          options={TASK_OPTIONS}
                          value={TASK_OPTIONS.find(o => o.value === field.value)}
                          classNamePrefix="react-select"
                          styles={customStyles}
                          onChange={(opt) => field.onChange(opt.value)}
                        />
                      )}
                    />
                  </FormGroup>
                </div>
                <div className="col-md-6 mb-3">
                  <Form.Group className="position-relative focus-z-index">
                    <label className="form-label">Assigned To </label>
                    <Controller
                      name="task_assigned_to"
                      control={control}
                      render={({ field }) => {

                        return <Select
                          options={users}
                          value={users.find((user) => user.value === field.value)}
                          onChange={(selectedOption) =>
                            field.onChange(selectedOption.value)
                          }
                          isSearchable
                          classNamePrefix="react-select"

                          styles={customStyles}
                        />

                      }}
                    />
                  </Form.Group>
                </div>

                <div style={{ height: 80 }} className="col-md-12"></div>
              </div>
            </div>
          </div>

          <div
            className="d-flex align-items-center gap-1 justify-content-end"
            style={{
              // border:"1px solid black",
              position: "fixed",
              width: "70%",
              marginLeft: "-15px",
              padding: "19px 28px",
              bottom: "0px",
              background: "#fff",
              borderTop: "1px solid #d3f4ff",
            }}
          >
            <button className="btn btn-default-outline" onClick={onCanvasClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-default">
              {editTask === true ? "Update" : "Submit"}
            </button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};
